import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateWithProfileAndLocalTimezoneComponent } from './date-with-profile-and-local-timezone.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DateWithProfileAndLocalTimezoneComponent],
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconModule],
  exports: [DateWithProfileAndLocalTimezoneComponent],
})
export class DateWithProfileAndLocalTimezoneModule {}
